"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PunchErrorModal = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const Button_1 = require("@amzn/atoz-web/Button");
const Modal_1 = require("@amzn/atoz-web/Modal");
const Col_1 = require("@amzn/atoz-web/Col");
const Text_1 = require("@amzn/atoz-web/Text");
const ErrorPerson_web_1 = require("../../components/Shared/ErrorPerson/ErrorPerson.web");
const PunchErrorModal = ({ retry, close }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const buttons = [
        react_1.default.createElement(Button_1.Button, { key: "PunchErrorModalCloseButton", variant: Button_1.ButtonVariant.Secondary, onClick: close, dataTestId: "PunchErrorModalCloseButton" }, t('time_and_attendance_PunchErrorModal_Ok')),
        react_1.default.createElement(Button_1.Button, { key: "PunchErrorModalRetryButton", variant: Button_1.ButtonVariant.Primary, onClick: retry, dataTestId: "PunchErrorModalRetryButton" }, t('time_and_attendance_PunchErrorModal_Try_Again'))
    ];
    return (react_1.default.createElement(Modal_1.ModalContent, { dataTestId: 'PunchErrorModal', onCloseButtonClick: close, titleText: "", buttons: buttons },
        react_1.default.createElement(Col_1.Col, { dataTestId: "GenericErrorContent" },
            react_1.default.createElement(Text_1.H1, { fontSize: "T600" }, t('time_and_attendance_PunchErrorModal_Title')),
            react_1.default.createElement(Text_1.H2, { fontSize: "T400", margin: { bottom: 'S600' } }, t('time_and_attendance_PunchErrorModal_Content')),
            react_1.default.createElement(ErrorPerson_web_1.ErrorPerson, { alt: '' }))));
};
exports.PunchErrorModal = PunchErrorModal;
